/**
 * App-wide helper for turning any thrown error into a friendly, user-readable message.
 * Thin re-export of the SDK's translator so the whole UI shares one source of truth.
 *
 * Usage:
 *   toast.error(getErrorMessage(error, 'Failed to save donor.'));
 *   toast.error(getErrorMessage(error, { fallback: 'Search failed.', notFound: 'No donor found.' }));
 */
import {
  friendlyApiMessage,
  type FriendlyMessageOptions,
} from '../../../../../packages/sdk/src/errorMessage';

export const getErrorMessage = friendlyApiMessage;
export type { FriendlyMessageOptions };
export default getErrorMessage;
